import { CorporateApplicationStepSixTypes } from './types';
import ApplicationDocuments from '../common/documents/documents';

import commonStyles from '../common/styles.module.css';

const NewApplicationCorporateInfoStepSix = ({
  documents,
  applicationId,
  applicationStatus,
  search,
  allowedDocumentsCategories,
  errors,
  clearErrors,
  renameAvailable,
}: CorporateApplicationStepSixTypes) => (
  <div className={commonStyles.stepBlockWrapper} style={{ zIndex: 15 }}>
    <div className={commonStyles.stepBlockContent}>
      <ApplicationDocuments
        zIndex={15}
        applicationStatus={applicationStatus}
        applicationId={applicationId}
        documents={documents}
        allowedDocumentsCategories={allowedDocumentsCategories}
        errors={errors}
        clearErrors={clearErrors}
        search={search}
        renameAvailable={renameAvailable}
        isCorporate
      />
    </div>
  </div>
);

export default NewApplicationCorporateInfoStepSix;
